export default "__VITE_ASSET__CFzQ4pwN__"